module.exports = __webpack_public_path__ + "img/0151-envelope.4bfbfeea.svg";